import type { Theme } from '@emotion/react';
import { type SxProps, Stack, Box, Typography } from '@mui/material';
import AppTheme from '@libs/mui/AppTheme';
import { useIntl } from 'react-intl';
import { useAppSelector, useAppDispatch } from '@libs/redux/store';
import { setSearchFilter } from '@libs/redux/appUiSlice';

type TopBarFilterButtonsStackProps = {
  sx: SxProps<Theme>;
};

export const TopBarFilterButtonsStack = (props: TopBarFilterButtonsStackProps) => {
  const { sx } = props;
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const activeFilter = useAppSelector(state => state.appUi.searchFilter);

  return (
    <Stack sx={{ ...sx }} display="flex" direction="row" spacing={2} alignItems="center">
      <TopBarFilterButton
        isActive={activeFilter === 'clients'}
        onClick={() => dispatch(setSearchFilter('clients'))}
        text={intl.formatMessage({
          id: 'topBarFilterButton.clients',
          defaultMessage: 'Klienti',
        })}
      />
      <TopBarFilterButton
        isActive={activeFilter === 'material'}
        onClick={() => dispatch(setSearchFilter('material'))}
        text={intl.formatMessage({
          id: 'topBarFilterButton.material',
          defaultMessage: 'Materiál',
        })}
      />
      <TopBarFilterButton
        isActive={activeFilter === 'goods'}
        onClick={() => dispatch(setSearchFilter('goods'))}
        text={intl.formatMessage({
          id: 'topBarFilterButton.goods',
          defaultMessage: 'Zboží',
        })}
      />
    </Stack>
  );
};

type TopBarFilterButtonProps = {
  isActive: boolean;
  onClick?: () => void;
  text: string;
};

const TopBarFilterButton = (props: TopBarFilterButtonProps) => {
  const { isActive = false, onClick, text } = props;

  const buttonProps = {
    bgcolor: isActive ? AppTheme.palette.common.white : '',
    borderRadius: '5px',
    padding: '5px',
    color: isActive ? AppTheme.palette.primary.main : AppTheme.palette.common.white,
  };

  return (
    <Box {...buttonProps} onClick={onClick}>
      <Typography sx={{ minWidth: 'max-content', width: 'auto' }} fontSize="small">
        {text}
      </Typography>
    </Box>
  );
};
